<template>
  <div>
    <PageHeader :items="items" />
    <validation-observer ref="simpleRules">
      <div class="card">
        <div class="card-body">
          <div class="row mb-1">
            <div class="col-md-6">
              <validation-provider
                #default="{ errors }"
                name="Invoice Type"
                rules="required"
              >
                <label class="input-label form-label"
                  >{{ $t("invoiceType") }}&nbsp;<span style="color: red"
                    >*</span
                  >
                </label>
                <multiselect
                  :disabled="invoiceStatus != 'draft'"
                  v-model="form.invoiceType"
                  :key="form.invoiceType"
                  :options="['invoice-correction', 'invoice', 'invoice-storno']"
                  :multiple="false"
                >
                </multiselect>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </div>
            <div class="col-md-6">
              <validation-provider
                #default="{ errors }"
                name="Status"
                rules="required"
              >
                <label class="input-label form-label"
                  >{{ $t("status") }}&nbsp;<span style="color: red">*</span>
                </label>
                <multiselect
                  v-model="form.status"
                  :key="form.status"
                  :options="statusOptions"
                  :multiple="false"
                >
                </multiselect>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </div>
          </div>
          <div class="row mb-1">
            <div class="col-md-6">
              <div class="form-group">
                <label class="input-label form-label"
                  >{{ $t("receiver") }}&nbsp;<span style="color: red">*</span>
                </label>
                <validation-provider
                  #default="{ errors }"
                  name="Receiver"
                  rules="required"
                >
                  <MultiSelectInput
                    v-model="form.companyId"
                    :options="customers"
                    label="companyName"
                    :isDisabled="invoiceStatus != 'draft'"
                    trackBy="id"
                    :key="form.companyId"
                    moduleName="customers"
                    :multiple="false"
                    :error="errors[0]"
                    ><template #option="{ props }">
                      <div>
                        <p>
                          {{ props.option.companyNumber }} -
                          {{ props.option.companyName }}
                        </p>
                      </div>
                    </template>
                  </MultiSelectInput>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label class="input-label form-label"
                  >{{ $t("sender") }}&nbsp;<span style="color: red">*</span>
                </label>
                <validation-provider
                  #default="{ errors }"
                  name="Sender"
                  rules="required"
                >
                  <MultiSelectInput
                    v-model="form.senderId"
                    :options="customers"
                    label="companyName"
                    :isDisabled="invoiceStatus != 'draft'"
                    trackBy="id"
                    :key="form.senderId"
                    moduleName="customers"
                    :multiple="false"
                    :error="errors[0]"
                    ><template #option="{ props }">
                      <div>
                        <p>
                          {{ props.option.companyNumber }} -
                          {{ props.option.companyName }}
                        </p>
                      </div>
                    </template>
                  </MultiSelectInput>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </div>
            </div>
          </div>
          <div class="row mb-1">
            <div class="col-md-6">
              <validation-provider
                #default="{ errors }"
                name="Start Date"
                rules="required"
              >
                <DatePicker
                  v-model="form.startDate"
                  :label="$t('startDate')"
                  :required="true"
                  :isDisabled="invoiceStatus !== 'draft'"
                  :isLeftIcon="true"
                  :leftIconName="'dateIcon'"
                  :error="errors[0]"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </div>

            <div class="col-md-6">
              <validation-provider
                #default="{ errors }"
                name="End Date"
                rules="required"
              >
                <DatePicker
                  v-model="form.endDate"
                  :label="$t('endDate')"
                  :required="true"
                  :isDisabled="invoiceStatus !== 'draft'"
                  :isLeftIcon="true"
                  :leftIconName="'dateIcon'"
                  :error="errors[0]"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </div>
          </div>
          <div class="row mb-1">
            <div class="col-md-6">
              <validation-provider
                #default="{ errors }"
                name="Due Date"
                rules="required"
              >
                <DatePicker
                  v-model="form.dueDate"
                  :label="$t('dueDate')"
                  :required="true"
                  :isLeftIcon="true"
                  :isDisabled="invoiceStatus !== 'draft'"
                  :leftIconName="'dateIcon'"
                  :error="errors[0]"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </div>
            <div class="col-md-6">
              <DatePicker
                v-model="form.invoiceDate"
                :label="$t('invoiceDate')"
                :isLeftIcon="true"
                :isDisabled="invoiceStatus !== 'draft'"
                :leftIconName="'dateIcon'"
              />
            </div>
          </div>
          <div class="row mb-1">
            <div class="col-md-6">
              <label class="input-label form-label" for="cars">{{
                $t("applyReverseCharge")
              }}</label>

              <input
                id="active"
                :disabled="invoiceStatus != 'draft'"
                class="form-check-input-custom ml-2"
                v-model="form.applyReverseCharge"
                type="checkbox"
              />
            </div>
            <div v-if="form.invoiceType == 'invoice-storno'" class="col-md-6">
              <label class="input-label form-label" for="cars">{{
                $t("referenceInvoice")
              }}</label>
              <MultiSelectInput
                v-model="referenceInvoiceDetail"
                :options="referenceInvoices"
                label="invoiceNumber"
                trackBy="id"
                :isDisabled="invoiceStatus != 'draft'"
                :key="referenceInvoiceDetail"
                moduleName="invoices"
                :multiple="false"
              >
              </MultiSelectInput>
            </div>
          </div>
          <div class="row mb-1">
            <div class="col-md-6">
              <div class="form-group">
                <label class="input-label form-label"
                  >{{ $t("assignedToReseller") }}
                </label>

                <MultiSelectInput
                  :key="form.resellerId"
                  v-model="form.resellerId"
                  :options="resellers"
                  label="companyName"
                  trackBy="id"
                  moduleName="customers"
                  :multiple="false"
                  :isDisabled="!$can2('reseller.edit')"
                  :action="'resellers'"
                  :query="{ isReseller: true }"
                  ><template #option="{ props }">
                    <div>
                      <p>
                        {{ props.option.companyNumber }} -
                        {{ props.option.companyName }}
                      </p>
                    </div>
                  </template>
                </MultiSelectInput>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label class="input-label form-label"
                  >{{ $t("assignedToSalesPartner") }}
                </label>
                <MultiSelectInput
                  :key="form.salesPartnerId"
                  v-model="form.salesPartnerId"
                  :options="salesPartners"
                  label="companyName"
                  trackBy="id"
                  :isDisabled="!$can2('sales-partner.edit')"
                  moduleName="customers"
                  :multiple="false"
                  :action="'salesPartners'"
                  :query="{ isSalesPartner: true }"
                  ><template #option="{ props }">
                    <div>
                      <p>
                        {{ props.option.companyNumber }} -
                        {{ props.option.companyName }}
                      </p>
                    </div>
                  </template>
                </MultiSelectInput>
              </div>
            </div>
          </div>
          <div class="row mb-1">
            <div class="col-md-6">
              <TextInput
                v-model="form.externalOrderNumber"
                type="text"
                :disabled="invoiceStatus != 'draft'"
                :label="$t('externalOrderNumber')"
              />
            </div>
            <div class="col-md-6">
              <label class="input-label form-label" for="cars">{{
                $t("customNotesField")
              }}</label>
              <textarea
                :disabled="invoiceStatus != 'draft'"
                class="form-control"
                rows="5"
                v-model="form.customNotesFields"
              />
            </div>
          </div>
        </div>
      </div>
      <CompanyCard :form="form" :user="user" />

      <div class="card">
        <div class="card-header" aria-label="Products Header">
          <h3 class="card-title">
            {{ $t("products") }}
          </h3>
        </div>
        <div class="card-body px-3" aria-label="Products Body">
          <div class="w-100">
            <div
              v-for="(products, index) in form.products"
              :key="index"
              class="mb-2"
            >
              <div class="row align-items-start">
                <div class="col-md-2">
                  <validation-provider
                    #default="{ errors }"
                    name="Product Name"
                    rules="required"
                  >
                    <text-input
                      v-model="products.productName"
                      :label="$t('productName')"
                      :required="true"
                      :disabled="invoiceStatus != 'draft'"
                      :maxLength="100"
                      aria-label="Product Name Input"
                      :error="errors[0]"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </div>

                <div class="col-md-1">
                  <validation-provider
                    #default="{ errors }"
                    name="Quantity"
                    rules="required"
                  >
                    <text-input
                      v-model="products.quantity"
                      :label="$t('quantity')"
                      :required="true"
                      :disabled="invoiceStatus != 'draft'"
                      type="number"
                      :maxLength="100"
                      @input="quantityChanged($event, index)"
                      aria-label="Quantity Input"
                      :error="errors[0]"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </div>
                <div class="col-md-1">
                  <validation-provider
                    #default="{ errors }"
                    name="Tax"
                    rules="required"
                  >
                    <text-input
                      v-model="products.tax"
                      :label="$t('tax')"
                      :required="true"
                      :disabled="invoiceStatus != 'draft'"
                      type="number"
                      :maxLength="100"
                      aria-label="Tax Input"
                      :error="errors[0]"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </div>
                <div class="col-md-2">
                  <validation-provider
                    #default="{ errors }"
                    name="Credits"
                    rules="required"
                    class="w-100"
                  >
                    <text-input
                      v-model="products.credits"
                      :label="$t('credits')"
                      :required="true"
                      :maxLength="100"
                      :disabled="invoiceStatus != 'draft'"
                      type="number"
                      @input="priceChanged($event, index)"
                      aria-label="Credits Input"
                      :error="errors[0]"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </div>
                <div class="col-md-2">
                  <label class="input-label form-label"
                    >{{ $t("totalCredits") }}&nbsp;<span style="color: red"
                      >*</span
                    >
                  </label>
                  <div class="mb-1 form-control">
                    <div>
                      {{
                        $formatter(
                          products.totalCredits,
                          $i18n.locale,
                          "EUR",
                          false,
                          2,
                          2
                        )
                      }}
                    </div>
                  </div>
                </div>
                <div class="col-md-2">
                  <validation-provider
                    #default="{ errors }"
                    name="Credit Price"
                    rules="required"
                    class="w-100"
                  >
                    <text-input
                      v-model="products.creditPrice"
                      :label="$t('⌀CreditPrice')"
                      :required="true"
                      :disabled="invoiceStatus != 'draft'"
                      type="number"
                      @input="creditPriceChanged($event, index)"
                      aria-label="Credit Price Input"
                      :error="errors[0]"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </div>
                <div class="col-md-2 d-flex align-items-center gap-2">
                  <div class="w-100">
                    <label class="input-label form-label"
                      >{{ $t("productPrice") }}&nbsp;<span style="color: red"
                        >*</span
                      >
                    </label>
                    <div class="form-control">
                      <div>
                        {{
                          $formatter(
                            products.nettoTotal,
                            $i18n.locale,
                            "EUR",
                            false,
                            2,
                            2
                          )
                        }}
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="invoiceStatus == 'draft'"
                    style="margin-top: 8px"
                    role="button"
                    @click="deleteProducts(index)"
                    aria-label="Delete Products button"
                  >
                    <feather-icon icon="XIcon" size="30" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="form.products.length > 0"
            class="d-flex align-items-center justify-content-end mt-2"
          >
            <div class="product-total">
              <ul>
                <li>
                  <h3>{{ $t("netto") }}</h3>
                  <p>
                    {{
                      $formatter(totalNetto, $i18n.locale, "EUR", false, 2, 2)
                    }}
                  </p>
                </li>
                <div v-if="!form.applyReverseCharge">
                  <li v-for="(tax, index) in calculateTax" :key="index">
                    <h3>Tax {{ tax.percent }}%</h3>
                    <p>
                      {{
                        $formatter(tax.amount, $i18n.locale, "EUR", false, 2, 2)
                      }}
                    </p>
                  </li>
                </div>
                <li class="total">
                  <h3>{{ $t("total") }}</h3>
                  <p>
                    {{
                      $formatter(totalAmount, $i18n.locale, "EUR", false, 2, 2)
                    }}
                  </p>
                </li>
              </ul>
            </div>
          </div>
          <b-button
            v-if="invoiceStatus == 'draft'"
            variant="primary"
            @click="addProducts"
            class="mt-2"
          >
            <feather-icon :icon="'PlusIcon'" size="16" />
            <span>
              {{ $t("addProducts") }}
            </span>
          </b-button>
        </div>
      </div>

      <div class="d-flex align-items-center justify-content-end">
        <b-button
          v-if="form.invoiceType === 'invoice' && invoiceStatus !== 'draft'"
          :disabled="isLoading"
          variant="warning"
          @click="cancelInvoice"
          class="d-flex align-items-center gap-1 mr-2"
        >
          <feather-icon icon="PlusIcon" size="12" />
          <span>{{ $t("cancelInvoice") }}</span>
        </b-button>
        <b-button
          :disabled="isLoading"
          variant="success"
          @click="copyInvoice"
          class="d-flex align-items-center gap-1 mr-2"
        >
          <feather-icon icon="PlusIcon" size="12" />
          <span>{{ $t("copyInvoice") }}</span>
        </b-button>
        <b-button
          :disabled="isLoading"
          variant="primary"
          @click="generate('pdf')"
          class="d-flex align-items-center gap-1 mr-2"
        >
          <feather-icon icon="PlusIcon" size="12" />
          <span>{{ $t("generatePdf") }}</span>
        </b-button>
        <b-button
          :disabled="isLoading"
          variant="primary"
          @click="generate('docx')"
          class="d-flex align-items-center gap-1 mr-2"
        >
          <feather-icon icon="PlusIcon" size="12" />
          <span>{{ $t("generateDocx") }}</span>
        </b-button>
        <b-button
          v-if="form.status.includes('warning')"
          :disabled="isLoading"
          variant="primary"
          @click="generate('pdf', true)"
          class="d-flex align-items-center gap-1 mr-2"
        >
          <feather-icon icon="PlusIcon" size="12" />
          <span>{{ $t("generateWarning") }}</span>
        </b-button>

        <b-button
          :disabled="isLoading"
          variant="primary"
          @click="updateInvoice"
          class="d-flex align-items-center gap-1"
          v-if="$can(`${$route.meta.permission}.edit`)"
        >
          <feather-icon icon="PlusIcon" size="12" />
          <span>{{ $t("updateInvoice") }}</span>
        </b-button>
      </div>
    </validation-observer>
  </div>
</template>

<script>
import TextInput from "@/components/TextInput.vue";
import PageHeader from "@/components/PageHeader.vue";
import Multiselect from "vue-multiselect";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { mapGetters } from "vuex";
import NotificationService from "@/services/notification.service";
import { required, email } from "@validations";
import MultiSelectInput from "@/components/MultiSelectInput.vue";
import DatePicker from "@/components/DatePicker.vue";
import ElementsIcon from "@/components/elements/Icon.vue";
import formDirtyMixin from "@/mixins/formDirtyMixin";
import CompanyCard from "./components/CompanyCard.vue";
export default {
  components: {
    TextInput,
    PageHeader,
    ValidationProvider,
    ValidationObserver,
    Multiselect,
    MultiSelectInput,
    DatePicker,
    ElementsIcon,
    CompanyCard,
  },
  mixins: [formDirtyMixin],
  watch: {
    referenceInvoiceDetail(newVal) {
      if (
        this.form.customNotesFields?.includes(
          "Cancellation invoice to invoice # "
        )
      ) {
        this.form.customNotesFields =
          "Cancellation invoice to invoice # " + newVal?.invoiceNumber;
      }
    },
    form: {
      handler(newVal) {
        this.isFormDirty = JSON.stringify(newVal) !== this.originalForm;
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters("customers", ["customers", "resellers", "salesPartners"]),
    ...mapGetters("invoices", ["referenceInvoices"]),
    totalNetto() {
      return this.form.products.reduce((sum, product) => {
        return sum + parseFloat(product.nettoTotal || 0);
      }, 0);
    },
    totalAmount() {
      // Sum all the taxes from calculateTax and add totalNetto
      const totalTaxes = this.calculateTax.reduce((sum, tax) => {
        return sum + parseFloat(tax.amount);
      }, 0);

      return parseFloat(this.totalNetto + totalTaxes).toFixed(2);
    },
    calculateTax() {
      if (this.form.applyReverseCharge) {
        // If reverse charge is applied, all amounts should be zero
        return Object.keys(
          this.form.products.reduce((result, product) => {
            result[product.tax] = 0;
            return result;
          }, {})
        ).map((tax) => ({
          percent: tax,
          amount: "0.00",
        }));
      }

      const groupedProducts = this.form.products.reduce((result, product) => {
        const tax = product.tax;
        if (!result[tax]) {
          result[tax] = [];
        }
        result[tax].push(product);
        return result;
      }, {});

      const result = Object.entries(groupedProducts).map(([tax, products]) => {
        const totalTaxAmount = products.reduce((sum, product) => {
          const nettoTotal = parseFloat(product.nettoTotal) || 0;
          const taxAmount = (nettoTotal * parseFloat(tax)) / 100;
          return sum + taxAmount;
        }, 0);

        return {
          percent: tax,
          amount: parseFloat(totalTaxAmount).toFixed(2),
        };
      });

      return result;
    },
    items() {
      return [
        {
          text: "Dental Twin",
          to: "/home",
        },
        {
          text: this.$t("invoices"),
          to: "/invoices",
        },
        {
          text: this.$t("edit"),
          active: true,
        },
      ];
    },
  },
  data() {
    return {
      originalForm: null,
      statusOptions: [],
      reminderLevels: [],
      invoiceStatus: "",
      form: {
        invoiceType: "",
        companyId: "",
        dueDate: "",
        startDate: "",
        endDate: "",
        invoiceDate: "",
        externalOrderNumber: "",
        applyReverseCharge: false,
        products: [],
        status: "",
        invoiceNumber: "",
        customNotesFields: "",
        resellerId: "",
        salesPartnerId: "",
        senderId: "",
      },
      referenceInvoiceDetail: "",
      isLoading: false,
      user: {
        first_name: "",
        last_name: "",
      },
      modelData: {},
    };
  },
  async created() {
    try {
      this.$store.commit("showLoader", true);
      await this.$store.dispatch("customers/list");
      await this.$store.dispatch("invoices/list", {
        isReference: true,
      });
      try {
        this.$store.commit("showLoader", true);
        await this.$store.dispatch("customers/resellers", {
          isReseller: true,
        });
        await this.$store.dispatch("customers/salesPartners", {
          isSalesPartner: true,
        });
      } catch (e) {
        console.error("api error ___", e);
      } finally {
        this.$store.commit("showLoader", false);
      }
      this.loadItems();
      let reminders = await this.$store.dispatch("invoiceReminderLevel/list");
      this.reminderLevels = reminders?.data?.data;
      const response = await this.$store.dispatch(
        "invoices/documentAssignmentList"
      );
      this.modelData = response?.data?.data ?? {};
    } catch (e) {
      console.error("api error ___", e);
    } finally {
      this.$store.commit("showLoader", false);
    }
  },
  methods: {
    filterStatusOptions(status) {
      const allOptions = [
        "draft",
        "approved",
        "sent",
        "warning level 1",
        "warning level 2",
        "warning level 3",
        "paid",
      ];

      const statusIndex = allOptions.indexOf(status);

      if (statusIndex !== -1) {
        // Update statusOptions to remove all previous statuses
        this.statusOptions = allOptions.slice(statusIndex);
      } else {
        // If the status is not found, keep all options
        this.statusOptions = allOptions;
      }
    },
    async loadItems() {
      await this.$store
        .dispatch("invoices/show", this.$route.params.id)
        .then((res) => {
          let data = res?.data?.data;
          this.filterStatusOptions(data.status);
          this.invoiceStatus = data.status;
          this.getUser(data.userId);
          this.form.invoiceType = data.invoiceType;
          this.form.customNotesFields = data.customNotesFields;
          this.form.companyId = data.company;
          this.form.senderId = data.sender;
          this.form.dueDate = data.dueDate;
          this.form.startDate = data.startDate;
          this.form.invoiceNumber = data.invoiceNumber;
          this.form.endDate = data.endDate;
          this.form.invoiceDate = data.invoiceDate;
          this.form.status = data.status;
          this.referenceInvoiceDetail = data.referenceInvoiceDetail;
          this.form.externalOrderNumber = data.externalOrderNumber;
          this.form.applyReverseCharge = data.applyReverseCharge;
          this.form.products = data.products;
          this.form.resellerId = data.resellerCompany;
          this.form.salesPartnerId = data.salesPartnerCompany;

          this.form.products = this.form.products.map(p => ({
            ...p,
            productName: this.translatedProductName(p.productName)
          }));

          this.originalForm = JSON.stringify(this.form);
        });
    },
    addProducts() {
      this.form.products.push({
        // pos: this.form.products.length + 1,
        productName: "",
        // caseName: "",
        credits: "",
        quantity: "",
        tax: "19",
        totalCredits: "",
        creditPrice: 1,
        nettoTotal: "0.00",
      });
    },
    getUser(id) {
      this.$store
        .dispatch("users/show", {
          id: id,
        })
        .then(async (res) => {
          if (res.message_type === "error") {
          } else {
            var response = res?.data;

            this.user.first_name = response.first_name;
            this.user.last_name = response.last_name;
          }
        });
    },
    quantityChanged(event, index) {
      this.form.products[index].nettoTotal =
        event *
        this.form.products[index].credits *
        this.form.products[index].creditPrice;
      this.form.products[index].totalCredits =
        event * this.form.products[index].credits;
    },
    creditPriceChanged(event, index) {
      this.form.products[index].nettoTotal =
        event *
        this.form.products[index].credits *
        this.form.products[index].quantity;
    },
    priceChanged(event, index) {
      this.form.products[index].nettoTotal =
        event *
        this.form.products[index].creditPrice *
        this.form.products[index].quantity;
      this.form.products[index].totalCredits =
        event * this.form.products[index].quantity;
    },
    async deleteProducts(index) {
      const confirmed = await this.showConfirmationDialog({
        title: this.$t("doYouWantToDeleteThisRecord"),
        subText: this.$t("yesDeleteIt"),
      });

      if (confirmed) {
        this.form.products.splice(index, 1);
      }
    },
    async copyInvoice() {
          const totalTaxes = this.calculateTax.reduce((sum, tax) => {
            return sum + parseFloat(tax.amount);
          }, 0);
          this.$store.commit("showLoader", true);
          this.isLoading = true;
          await this.$store
            .dispatch("invoices/create", {
              ...this.form,
              companyId: this.form.companyId?.id ?? "",
              totalAmount: this.totalAmount,
              taxAmount: totalTaxes,
              netto: this.totalNetto,
              status: 'draft'
            })
            .finally(() => {
              this.isLoading = false;
              this.$store.commit("showLoader", false);
              this.$router.push("/invoices");
            });
    },
    async cancelInvoice() {
          const totalTaxes = this.calculateTax.reduce((sum, tax) => {
            return sum + parseFloat(tax.amount);
          }, 0);

          var products = this.form.products.map((product) => {
            return {
              ...product,
              quantity: -1 * parseFloat(product.quantity), // Convert to negative and keep it as string,
              nettoTotal: -1 * parseFloat(product.nettoTotal),
            };
          });
          this.isLoading = true;
          this.$store.commit("showLoader", true);
          if (this.form.status != "paid") {
            await this.$store.dispatch("invoices/updateStatus", {
                id: this.$route.params.id,
                data: {
                    status: 'paid',
                },
            });
          }
          await this.$store
            .dispatch("invoices/create", {
              ...this.form,
              products: products,
              invoiceType: "invoice-storno",
              status: "draft",
              referenceInvoiceId:
                this.referenceInvoiceDetail?.id ?? this.$route.params.id,
              companyId: this.form.companyId?.id ?? "",
              totalAmount: -1 * this.totalAmount,
              taxAmount: -1 * totalTaxes,
              netto: -1 * this.totalNetto,
              customNotesFields:
                "Cancellation invoice to invoice # " +
                (this.referenceInvoiceDetail?.invoiceNumber ??
                  this.form.invoiceNumber),
            })
            .finally(() => {
              this.$store.commit("showLoader", false);
              this.isLoading = false;
              this.$router.push("/invoices");
            });
    },
    async generate(documentType, isWarning = false) {
      let templateId;
      let warningLevel = {};

      if (this.form.status.startsWith("warning level")) {
        const matchedLevel = this.reminderLevels.find(
          (level) => level.levelName === this.form.status
        );
        if (isWarning == true) {
          if (matchedLevel) {
            const { id, ...rest } = matchedLevel; // Destructure to exclude 'id'
            // Copy the matchedLevel object except for the 'id' property
            warningLevel = { ...rest }; // Assign the rest of the properties to warningLevel
          }
        }
        templateId = matchedLevel ? matchedLevel.documentTemplateId : "";
      } else {
        // Handle other cases based on the form status
        switch (this.form.status) {
          case "invoice":
            templateId = this.modelData?.invoiceTemplateId ?? "";
            break;
          case "invoice-correction":
            templateId = this.modelData?.invoiceCorrectionTemplateId ?? "";
            break;
          case "invoice-storno":
            templateId = this.modelData?.invoiceStornoTemplateId ?? "";
            break;
          default:
            templateId = this.modelData?.invoiceTemplateId ?? ""; // Fallback to invoiceTemplateId
        }
      }
      if (templateId != "") {
        // Safeguard to ensure convertDate returns a valid Date object
        const parseDate = (date) => {
          const parsedDate = this.convertDate(date);
          return parsedDate instanceof Date && !isNaN(parsedDate)
            ? parsedDate
            : new Date(date);
        };

        const invoiceDate = this.form?.invoiceDate
          ? parseDate(this.form.invoiceDate)
          : this.formatDateLite(new Date());

        const startDate = this.form?.startDate
          ? parseDate(this.form.startDate)
          : null;

        const endDate = this.form?.endDate
          ? parseDate(this.form.endDate)
          : null;

        const dueDate = this.form?.dueDate
          ? parseDate(this.form.dueDate)
          : null;

        const draftStatusChangeDate = this.form?.invoiceDate
          ? parseDate(this.form.invoiceDate)
          : null;
        const totalTaxes = this.calculateTax.reduce((sum, tax) => {
          return sum + parseFloat(tax.amount);
        }, 0);
        // Create the payload
        const payload = {
          ...this.form,
          invoiceStatus: this.form.status,
          customers: this.form.companyId,
          sender: this.form.senderId,
          totalAmount: this.totalAmount,
          totalTaxAmount: totalTaxes,
          totalAmountWithoutTax: this.totalNetto,
          invoiceDate: invoiceDate.toLocaleDateString(),
          startDate: startDate ? startDate.toLocaleDateString() : null,
          endDate: endDate ? endDate.toLocaleDateString() : null,
          dueDate: dueDate ? dueDate.toLocaleDateString() : null,
          draftStatusChangeDate: draftStatusChangeDate
            ? draftStatusChangeDate.toLocaleDateString()
            : "",
          id: templateId,
          output: documentType,
          updatedTime: Date.now(),
          ...warningLevel,
        };

        // Generate the filename
        const filename =
          "invoice-" +
          (this.form.invoiceNumber == null
            ? "draft"
            : this.form.invoiceNumber) +
          `.${documentType}`;

        // Dispatch the action
        this.$store.commit("showLoader", true);
        const response = await this.$store
          .dispatch("documentService/processTemplate", {
            data: payload,
            filename: filename,
            documentType: documentType,
          })
          .finally(() => {
            this.$store.commit("showLoader", false);
          });

        // If response is Blob, convert to Base64
        if (response instanceof Blob) {
          await this.convertBlobToBase64(response);
        }
      } else {
        NotificationService.showError("Please assign document template first");
      }
    },
    convertDate(dateString) {
      // Convert the date string into a Date object
      const date = new Date(dateString);

      // Convert the date to the desired format (Pakistan Standard Time)
      // Forcing timezone shift by setting the time to GMT+0500
      date.setTime(date.getTime() + 5 * 60 * 60 * 1000); // Add 5 hours

      // Return the formatted string
      return date.toString();
    },
    formatDateLite(date, showTime = false) {
      try {
        const m = date.getMonth() + 1;
        const d = date.getDate();
        return `${date.getFullYear()}-${m < 10 ? "0" : ""}${m}-${
          d < 10 ? "0" : ""
        }${d}${showTime ? " " + date.toLocaleTimeString() : ""}`;
      } catch (e) {
        return date;
      }
    },
    convertBlobToBase64(data) {
      return new Promise((resolve, reject) => {
        var reader = new FileReader();
        reader.readAsDataURL(data);
        reader.onerror = (err) => {
          reject(err);
        };
        reader.onloadend = () => {
          resolve(reader.result);
        };
      });
    },
    async updateInvoice() {
      this.$refs.simpleRules.validate().then(async (success) => {
        if (success) {
          let payload = {};
          let storeDispatch = "invoices/update";
          if (this.invoiceStatus !== "draft") {
            payload = {
              status: this.form.status,
              salesPartnerId: this.form.salesPartnerId?.id ?? "",
              resellerId: this.form.resellerId?.id ?? "",
            };
            storeDispatch = "invoices/updateStatus";
          } else {
            const totalTaxes = this.calculateTax.reduce((sum, tax) => {
              return sum + parseFloat(tax.amount);
            }, 0);

            payload = {
              ...this.form,
              companyId: this.form.companyId?.id ?? "",
              senderId: this.form.senderId?.id ?? "",
              salesPartnerId: this.form.salesPartnerId?.id ?? "",
              resellerId: this.form.resellerId?.id ?? "",
              totalAmount: this.totalAmount,
              taxAmount: totalTaxes,
              referenceInvoiceId: this.referenceInvoiceDetail?.id ?? null,
              netto: this.totalNetto,
            };
          }

          this.isLoading = true;
          await this.$store
            .dispatch(storeDispatch, {
              id: this.$route.params.id,
              data: payload,
            })
            .finally(() => {
              this.isLoading = false;
            });

          this.isFormDirty = false;
          this.originalForm = JSON.stringify(this.form);
          this.$router.push("/invoices");
        }
      });
    },
  },
};
</script>

<style scoped>
#nprogress {
  position: relative;
  z-index: 9999999;
}

.white-color {
  color: white !important;
}

.vgt-responsive {
  overflow-x: visible !important;
}
</style>
